export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-700-c18ee39fb002ad58b6dc595476f88fef.woff2";